import { useEffect, useState } from 'react'
import { getProjectInvoices } from '@/lib/api/projects'
import type { ProjectInvoicesResponse } from '@/types'

export function useProjectInvoices(projectId: string | undefined) {
  const [data, setData] = useState<ProjectInvoicesResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)

  const refetch = async () => {
    if (!projectId) return

    setIsLoading(true)
    setError(null)

    try {
      const response = await getProjectInvoices(projectId)
      setData(response)
    } catch (e) {
      setError(e)
      setData(null)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!projectId) return

    let cancelled = false
    setIsLoading(true)
    setError(null)

    getProjectInvoices(projectId)
      .then((d) => {
        if (cancelled) return
        setData(d)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setData(null)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [projectId])

  return { data, isLoading, error, refetch }
}
